module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "type": "dark"
    }
  }), _vm._v(" "), _c('form-venda')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4279752b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sale.vue
// module id = 741
// module chunks = 7